import './style.css';
import { bootstrapApp } from './app/bootstrap.ts';

bootstrapApp().catch((err) => {
  const overlay = document.getElementById('overlay');
  const msg = err instanceof Error ? err.message : String(err);
  if (overlay) {
    overlay.style.color = '#e55';
    overlay.textContent = `Startup failed:\n${msg}`;
  }
  console.error('Startup failed:', err);
});
